function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { message, Button } from 'antd';
import Common from "./includes/Common";
import { Table, Container, Row, Col, Spinner } from 'react-bootstrap';
import { Eyedropper } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var DisplayLabReport = function DisplayLabReport(_ref) {
  var timeFrame = _ref.timeFrame;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    customersData = _useState4[0],
    setCustomersData = _useState4[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getlabohistory/' + timeFrame[0]._d + '/' + timeFrame[1]._d + '/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCustomersData(response.data.customers);
      } else {}
    })["catch"](function (error) {})["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Table, {
      style: {
        height: '500px',
        overflow: 'scroll'
      },
      responsive: true,
      children: [/*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: "N.Echant."
          }), /*#__PURE__*/_jsx("th", {
            children: "Date"
          }), /*#__PURE__*/_jsx("th", {
            children: "RNC"
          }), /*#__PURE__*/_jsx("th", {
            children: "Pr\xE9nom"
          }), /*#__PURE__*/_jsx("th", {
            children: "Nom"
          }), /*#__PURE__*/_jsx("th", {
            children: "T\xE9l\xE9phone"
          }), /*#__PURE__*/_jsxs("th", {
            children: [/*#__PURE__*/_jsx(Eyedropper, {
              size: 22
            }), " ", /*#__PURE__*/_jsx("b", {
              children: "G"
            })]
          }), /*#__PURE__*/_jsxs("th", {
            children: [/*#__PURE__*/_jsx(Eyedropper, {
              size: 22
            }), " ", /*#__PURE__*/_jsx("b", {
              children: "R"
            })]
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: customersData.map(function (c) {
          return /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              children: c.laboresult != null && c.laboresult.sampleid
            }), /*#__PURE__*/_jsx("td", {
              children: new Date(c.created_at).toLocaleDateString('Fr', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })
            }), /*#__PURE__*/_jsx("td", {
              children: c.rnc
            }), /*#__PURE__*/_jsx("td", {
              children: c.firstname
            }), /*#__PURE__*/_jsx("td", {
              children: c.lastname
            }), /*#__PURE__*/_jsx("td", {
              children: c.mobile
            }), /*#__PURE__*/_jsx("td", {
              children: c.laboresult != null && c.laboresult.group != null && c.laboresult.group
            }), /*#__PURE__*/_jsxs("td", {
              children: [c.laboresult != null && c.laboresult.rhesus != null && c.laboresult.rhesus == '+' && /*#__PURE__*/_jsx("b", {
                children: "Positif"
              }), c.laboresult != null && c.laboresult.rhesus != null && c.laboresult.rhesus == '-' && /*#__PURE__*/_jsx("b", {
                children: "N\xE9gatif"
              })]
            })]
          }, 'q' + c.id.toString());
        })
      })]
    }), isDataLoading && /*#__PURE__*/_jsx("div", {
      style: {
        textAlign: 'center'
      },
      children: /*#__PURE__*/_jsx(Spinner, {
        variant: "success",
        animation: "grow"
      })
    })]
  });
};
export default DisplayLabReport;